import {
  Component,
  ViewChild,
  TemplateRef,
  AfterViewInit,
  ChangeDetectorRef,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import {
  MatRowDef,
  MatTableModule,
} from "@angular/material/table";
import { MatDialogModule, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { CommonModule, NgIf } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatSelectModule } from "@angular/material/select";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatOptionModule } from "@angular/material/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatExpansionModule } from "@angular/material/expansion";
import { CompanyAttributes } from "@albatrosdeveloper/ave-models-package";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CompanyService } from "../../configuration/company/company.service.service";
import ReasonVisitAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/reason-visits/reason-visits.entity";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatMenuModule } from "@angular/material/menu";
import { MatTabsModule } from "@angular/material/tabs";
import {
  NgSelectComponent,
  NgSelectModule,
} from "@ng-select/ng-select";
import { ICreateReasonVisit } from "./interfaces/create-reason-for-visit.interface";
import { ReasonVisitService } from "./reason-for-visit.service";
import { IUpdateReasonVisit } from "./interfaces/update-reason-for-visit.interface";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { getCode } from 'app/utils/method';
import { FilterComponent } from "app/common/components/filter/filter.component";
import { Subscription } from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";


@Component({
  selector: "app-reason-for-visit",
  templateUrl: "./reason-for-visit.component.html",
  styleUrls: ["./reason-for-visit.component.scss"],
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent,
    NgSelectModule,
    MatTabsModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    FilterSectionComponent,
    HoverMenuDirective
],
standalone: true,
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
})
export class ReasonForVisitComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;
  displayedColumns: string[] = ["name", "requiresPhoto","status", "actions"];
  currentCreateReasonVisit: ICreateReasonVisit =
    this.initializeCreateReasonVisit();
  currentUpdateReasonVisit: ReasonVisitAttributes | undefined;

  dataSource: ReasonVisitAttributes[] = [];
  companyList: CompanyAttributes[] = [];

  searchQuery: string = "";
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 0;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  selectedStatuses: number[] = [0,1];

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  //BUSCADOR
  searchSubscription: Subscription;

  companyForm = new FormGroup({
    companyId: new FormControl(null)
  })
  
  constructor(
    private readonly reasonVisitService: ReasonVisitService,
    private readonly searchService: SearchService,
    private companyService: CompanyService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
    this.fetchAllCompanies();
  }

  private fetchAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.companyList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.","Cerrar",{ duration: 5000});
      },
    });
  }

  private initializeCreateReasonVisit(): ICreateReasonVisit {
    return { name: "", companyId: "", useGps: false };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";


    this.reasonVisitService
      .findAllWithCount({
        currentPage: pageIndex,
        limitPerPage: this.pageSize,
        search: this.searchQuery,
        sort: sortField,
        sortDirection: sortDirection,
      },
      this.companyForm.value.companyId ? [this.companyForm.value.companyId] : [],
      this.selectedStatuses)
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof ReasonVisitAttributes {
    const validSortFields: (keyof ReasonVisitAttributes)[] = [
      "name",
      "statusId",
    ];
    return validSortFields.includes(
      this.sort.active as keyof ReasonVisitAttributes
    )
      ? (this.sort.active as keyof ReasonVisitAttributes)
      : "name";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }
  
  trackByFn(index: number, item: ReasonVisitAttributes): string {
    return item._id.toString();
  }

  openCreateModal(): void {
    this.currentCreateReasonVisit = this.initializeCreateReasonVisit();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose:true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createReasonVisit());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(condition: ReasonVisitAttributes): void {
    this.currentUpdateReasonVisit = { ...condition };
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose:true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateReasonVisit(condition._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createReasonVisit(): void {
    this.reasonVisitService.create(this.currentCreateReasonVisit).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.findAllWithCount();
        this.dialogRefAdd.close();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  updateReasonVisit(id: string): void {
    if (this.currentUpdateReasonVisit) {
      const updatedReasonVisit: IUpdateReasonVisit = {
        ...this.currentUpdateReasonVisit,
        companyId: this.currentUpdateReasonVisit.company._id.toString(),
      };

      this.reasonVisitService.update(id, updatedReasonVisit).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
          this.dialogRefEdit.close();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  onStatusChange(event: boolean, condition: ReasonVisitAttributes): void {
    const originalStatusId = condition.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedReasonVisit = { ...condition, statusId: updatedStatusId };

    this.reasonVisitService
      .update(condition._id.toString(), updatedReasonVisit)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          condition.statusId = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  onPhotoChange(event: boolean, visit: ReasonVisitAttributes): void {
    const originalStatusId = visit.requiresPhoto;
    const updatedStatusId = event ? true: false;
    const updatedReasonVisit: IUpdateReasonVisit = { requiresPhoto: updatedStatusId };

    this.reasonVisitService
      .update(visit._id.toString(), updatedReasonVisit)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          visit.requiresPhoto = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  openDeleteDialog(condition: ReasonVisitAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: condition, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(condition._id.toString()));
  }

  delete(id: string): void {
    this.reasonVisitService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  onCompanySelectionChange(companyId: string): void {
    if (this.currentUpdateReasonVisit) {
      this.currentUpdateReasonVisit.company = this.companyList.find(
        (company) => company._id.toString() === companyId
      )!;
    }
  }


  clearFilters(): void {
    this.companyForm.reset();
    this.searchQuery = "";
    this.findAllWithCount();
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  applyStatusFilter(): void {
    this.paginator.pageIndex = 0;
    this.findAllWithCount();
  }
}
